import onboarding from "../animations/onboarding.json";
import signContract from "../animations/contract-sign.json";
import chatConcept from "../animations/chatConcept.json";
import security from "../animations/security.json";
import getInTouch from "../animations/getInTouch.json";

export const PHASES: { [key: string]: { name: string, description: string, icon: any } } = Object.freeze({
    ACCOUNT_VERIFICATION: {
        name: "Account Verification",
        description: "We are busy verifying that all your Merchant information is correct.",
        icon: onboarding
    },
    SIGN_CONTRACT: {
        name: "Sign Contract",
        description: "Your information has been verified and your contract is on its way.",
        icon: signContract
    },
    GO_LIVE: {
        name: "Go Live",
        description: "Your contract has been received and your live credentials are on their way.",
        icon: chatConcept
    },
    BUSINESS_RISK_VERIFICATION: {
        name: "Business Risk Verification",
        description: "Waiting for your FICA documents to complete your business verification.",
        icon: security

    },
    SETTLEMENTS: {
        name: "Settlements",
        description: "You have qualified and are ready for settlements.",
        icon: getInTouch
    }
});

export const PHASES_COLLECTION = [
    PHASES.ACCOUNT_VERIFICATION,
    PHASES.SIGN_CONTRACT,
    PHASES.GO_LIVE,
    PHASES.BUSINESS_RISK_VERIFICATION,
    PHASES.SETTLEMENTS
];

export const PEACH_SUPPORT_EMAIL = "support@peachpayments.com";